import React from 'react'

import { Dialog } from 'components'

const DeleteDialog = (props) => (
  <Dialog
    {...props}
    id='delete-artwork-dialog'
    title='Are you sure you want to delete this artwork?'
    width={400}
  >
    <p>
      This action cannot be undone. Your artwork and all its associated
      products will be permanently deleted.
    </p>
  </Dialog>
)

export default DeleteDialog



// WEBPACK FOOTER //
// ./src/containers/ArtworkView/View/DeleteDialog.js